import React from 'react';

const Loading = () => {
    return (
    <div className="loading">
        <div className="loading_text">
           <span className="loading_text_word">G E N E S I S</span>
        </div>
    </div>
    );
};

export default Loading;